import { createAsyncThunk } from '@reduxjs/toolkit';
import { createTableSlice } from '../helpers';
import { TaskStatus } from '../../constants';
import { apiFetch } from '../../api';

export const tableSlice = createTableSlice({
  name: 'inprogressTable',
  url: '/api/labelTasks',
  filters: { status: TaskStatus.TODO, all: 1 },
  sortOrder: 'desc',
  orderBy: 'LabelTask.id',
});

async function deleteLabelTasks(labelTaskIds) {
  return apiFetch(`/api/labelTasks/delete/bulk`, 'DELETE', { label_task_ids: labelTaskIds });
}

export const deleteSelectedLabelTasks = createAsyncThunk(
  `inprogress/deleteSelectedLabelTasks`,
  async (_, { getState, dispatch }) => {
    const selectedLabelTaskIds = tableSlice.selectors.selectSelectedRows(getState());
    await deleteLabelTasks(selectedLabelTaskIds);
    await dispatch(tableSlice.actions.clearSelection());
    await dispatch(tableSlice.actions.fetchRows());
  }
);

export const selectLabelTaskIds = tableSlice.selectors.selectSelectedRows;
